import { HomeScreen } from "@/components/home/HomeScreen";

/** Home (rebuild of My NOS "My Dashboard"). */
export function DashboardPage() {
  return <HomeScreen />;
}
